import {type ReactNode} from 'react';

export interface DropdownMenuItemContentProps {
  icon?: ReactNode;
  label: ReactNode;
  description?: ReactNode;
}

export function DropdownMenuItemContent({
  icon,
  label,
  description,
}: DropdownMenuItemContentProps) {
  return (
    <div className="flex items-center gap-3 text-[var(--chekin-color-brand-navy)] [&_svg]:text-[var(--chekin-neutral-400)]">
      {icon}
      <div>
        <div>{label}</div>
        {description && <div className="text-xs text-[#666]">{description}</div>}
      </div>
    </div>
  );
}
